import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { getSite } from '../tools/fetcher';
import TestimonialSlider from './TestimonialSlider';
import { classNames } from '../tools/helpers';

export default function Testimonial({
    className,
    classNameSlider,
    innerWidth,
}) {
    const { data } = useQuery({
        queryKey: ['sites'],
        queryFn: getSite,
    });

    return (
        <>
            <div className={className}>
                <div
                    className={classNames(
                        'flex flex-col gap-y-2 max-w-[560px] text-center',
                        innerWidth,
                    )}
                >
                    <p
                        className={
                            'font-bold leading-[36px] text-[32px] sm:leading-[48px] sm:text-[40px]'
                        }
                    >
                        {data?.testimonial?.title}
                    </p>
                    <p
                        className={
                            'text-primary-gray-101'
                        }
                    >
                        {data?.testimonial?.description}
                    </p>
                </div>
            </div>
            <div className={classNameSlider}>
                <div className={classNames('mt-4 sm:mt-[60px]', innerWidth)}>
                    <TestimonialSlider />
                </div>
            </div>
        </>
    );
}
